import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Row, Table, Modal, ModalBody, ModalHeader, Badge } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import Image from '../../components/Image'
import dummyRoundedImage from "../../assets/images/dummy-rounded-image.png"
import { getCallLogs, getCallRecordings } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { formatTimeFromSeconds, formatDate, formatTime } from '../../helper/format';
import { EmptyRow } from '../../components/EmptyState';
import { compressToEncodedURIComponent } from "lz-string";

const ListChats = () => {
  const history = useNavigate();
  const [loading, setLoading] = useState(false)
  const [callLogs, setCallLogs] = useState([])
  const [selectedLog, setSelectedLog] = useState({})
  const [viewModal, setViewModal] = useState(false);
  const [mode, setMode] = useState(false);
  const [keyword, setKeyword] = useState("");
  const keywordRef = useRef("");

  const [selectedVoice, setSelectedVoice] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentlyPlayingVoice, setCurrentlyPlayingVoice] = useState(null);
  const [voiceLoading, setVoiceLoading] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    fetchCallLogs();
  }, [])

  const fetchCallLogs = (keyword="") => {
    setLoading(true)
    setCallLogs([])
    getCallLogs({...(keyword && keyword.length && { search: keyword.replace(/^\+/, '') }), type: "chat"}).then((data) => {
      if (data.data) {
        setCallLogs(data.data ? data.data : [])
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
    })
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    setKeyword(keywordRef.current.value);
    fetchCallLogs(keywordRef.current.value)
  }


  const handleViewModal = (mode, log) => {
    setSelectedLog(log)
    setMode(mode)
    setViewModal(true)
  }

  const handlePlayPause = async (callSid, index) => {
    // If the same recording is clicked again
    if (currentlyPlayingVoice === index) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
      return;
    }

    // If a new recording is selected
    setVoiceLoading(true);
    setIsPlaying(false);
    setSelectedVoice(null);

    getCallRecordings(`?sid=${callSid}`).then((data) => {
      if (data) {
        const audioBlob = new Blob([data.data], { type: 'audio/mpeg' });
        const audioUrl = URL.createObjectURL(audioBlob);

        setSelectedVoice(audioUrl);
        setCurrentlyPlayingVoice(index);
        setIsPlaying(true);

        // Delay to ensure audio ref picks up new URL before playing
        setTimeout(() => {
          audioRef.current?.play();
        }, 100);
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setVoiceLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setVoiceLoading(false)
    })
  };

  const handleDownload = async (callSid) => {
    setVoiceLoading(true);
    getCallRecordings(`?sid=${callSid}`).then((data) => {
      if (data) {
        const blob = new Blob([data.data], { type: 'audio/mpeg' });
        const url = window.URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `recording-${callSid}.mp3`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setVoiceLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setVoiceLoading(false)
    })
  };
  return (
    <div className="content-page">
      <div className="content">

        <div className="container-fluid">

          <div className="py-3 py-3 row">
            <div className="col-12">

              <Row className="my-2 align-items-center">
                <Col md={8}>
                  <h4>Chat List</h4>
                  <p className='text-muted fs-12'>Manage and monitor your AI chats</p>
                </Col>
                {/* <Col md={4} className='text-right'>
                  <Link id='make-call-btn' to={"/make-call"} className="font-normal py-2 px-4 rounded fs-15 text-decoration-none text-white linear-gradient-btn"><i className="ri-phone-line"></i> Make Call</Link>
                </Col> */}
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  {/* <form className=""> */}
                    <div className='d-flex'>
                      <div className="position-relative w-70 me-2">
                        <input type="text" className="form-control p-2 ps-4" placeholder="Search..." ref={keywordRef} />
                        <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2"></i>
                      </div>
                      <Button type='button' disabled={loading} onClick={(e) => { searchByKeyword(e) }} className="font-normal py-2 px-4 rounded fs-14 linear-gradient-btn">Search</Button>
                    </div>
                  {/* </form> */}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Table hover responsive className='border-rounded custom-listing-tables'>
                    <thead>
                      <tr>
                        <th>Agent</th>
                        <th>Date</th>
                        <th className="text-center">Status</th>
                        <th>Transcript</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(30)].map((a, i) => {
                            return <tr key={i}>
                              <td className="fs-12"><div className='d-flex align-items-center'><Skeleton height={40} width={40} circle={true} className='me-2' /><Skeleton height={12} width={90} /></div></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={90} /></td>
                            </tr>
                          }) :
                          callLogs.length === 0 ?
                            <EmptyRow colSpan={10} icon="ri-chat-3-line" title="No chats in this range" body="Try widening the date range or clearing your filters." /> :
                            callLogs.map((log, i) => {
                              return <tr key={i}>
                                <td className="fs-12 fw-500"><div className='d-flex align-items-center'><Image src={dummyRoundedImage} alt="Event" className='rounded-circle me-2' height='40px' width='40px' objectFit='cover' /><p className='m-0'>{log.agentId ? log.agentId.name : "N/A"} <span className=' d-block text-muted fs-12 text-capitalize'>{log.agentId ? log.agentId.type : "N/A"}</span></p></div></td>
                                <td className="fs-12 fw-500 text-nowrap">
                                  {formatDate(log.createdAt)}
                                  <span className="d-block text-muted">{formatTime(log.createdAt)}</span>
                                </td>
                                <td className="fs-12 fw-500 text-center">{log.status === "completed" ? <Badge color='badge-success badge-soft-success fs-12 text-capitalize'>{log.status}</Badge> : <Badge color='badge-danger badge-soft-danger fs-12 text-capitalize'>{log.status}</Badge>}</td>
                                <td className="fs-12 fw-500">{log.transcript ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('transcript', log) }}>View Transcript</p> : "N/A"}</td>
                              </tr>
                            })

                      }
                    </tbody>
                  </Table>
                  {selectedVoice && (
                    <div className='d-none'>
                      <audio
                        controls
                        src={selectedVoice}
                        ref={audioRef}
                        onEnded={() => {
                          setIsPlaying(false);
                          setCurrentlyPlayingVoice(null);
                        }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='lg'>
              <ModalHeader toggle={() => { setViewModal(false) }}>
                <small>{mode === 'summary' ? "Summary" : "Transcript"}</small>
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={12} className='mb-4'>
                    <textarea disabled={true} value={mode === 'summary' ? selectedLog.summary : selectedLog.transcript} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                  </Col>
                </Row>
                <Row className="text-center mt-3">
                  <Col>
                    <button className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListChats
